import { OverlayScrollArea } from '@/components/ui/OverlayScrollArea/OverlayScrollArea';
import { HistoryChangeBody } from './HistoryChangeBody';
import { mapHistoryEntryToDisplay } from './mapHistoryEntryToDisplay';
import type { HistoryChangeSetGroup, HistoryDisplayEntry } from './types';

export function HistoryGroupCardBody<T extends HistoryDisplayEntry>({
  group,
  timeLabel,
}: {
  group: HistoryChangeSetGroup<T>;
  timeLabel: string;
}) {
  return (
    <>
      <div className="project-change-history-popover__item-meta-row">
        <span className="project-change-history-popover__item-author">{group.display_actor}</span>
        <span className="project-change-history-popover__item-sep" aria-hidden />
        <span className="project-change-history-popover__item-time">{timeLabel}</span>
      </div>
      <OverlayScrollArea
        className="project-change-history-popover__item-scroll"
        osOptions={{ overflow: { x: 'scroll', y: 'visible' } }}
      >
        <div className="project-change-history-popover__item-scroll-pad">
          <div className="project-change-history-popover__changes-grid">
            {group.items.map((item) => (
              <HistoryChangeBody key={item.id} model={mapHistoryEntryToDisplay(item)} />
            ))}
          </div>
        </div>
      </OverlayScrollArea>
    </>
  );
}
